import { createContext, useContext } from 'react';

// Hermano de `lib/contextoAuth.js`, y deliberadamente SEPARADO de él: las
// dos sesiones no comparten contexto ni almacenamiento. Mezclarlas es
// exactamente cómo se filtra un token de un lado al otro.
export const ContextoPanel = createContext(null);

export function useAuthPanel() {
  const ctx = useContext(ContextoPanel);
  if (!ctx) throw new Error('useAuthPanel debe usarse dentro de ProveedorAuthPanel');
  return ctx;
}
